import Rest from '../Rest'

export default class ProductRevenueService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/product_revenue'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }

  getProductRevenue(customFilters = {}) {
    const params = {}
    if (Object.keys(customFilters).length > 0) {
      params.custom_filters = customFilters
    }
    return this.get('/financial/product-revenue', params).then(data => {
      return data
    })
  }
}
